import { makeAutoObservable, toJS } from "mobx";
import { IApplicationStore } from "./applicationStore.d";

export class ApplicationStore implements IApplicationStore {
  theme: number;
  lang: string = "en";

  constructor() {
    makeAutoObservable(this);
  }

  setTheme(theme: number) {
    this.theme = theme;
  }

  getTheme() {
    return toJS(this.theme);
  }

  setLang(lang: string) {
    this.lang = lang;
  }

  getLang() {
    return toJS(this.lang);
  }
}

export default new ApplicationStore();
